const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Kontakt & Service",
  description:
    "Herzlich willkommen im Servicebereich von BRIDGESTONE PLUS. Hier finden Sie alle Kontaktdaten des Serviceteams.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Team Reifenhandel",
    car: "Team Autohaus",
    lkw: "Team Lkw",
    em_otr: "Team EM/OTR",
    farm_tractor: "Team Ackerschlepper",
    bandag: "Team Bandag",
  },
  contact: {
    index: {
      title: "Kontakt & Service",
      description:
        "Herzlich willkommen im Servicebereich von BRIDGESTONE PLUS. Hier finden Sie die Kontaktdaten unseres Serviceteams, sowie Ihre Ansprechpartner nach Region.",
    },
    categories: {
      service: {
        description: "Servicenummer für Ihre Region sowie E-Mail-Kontakt",
      },
      form: {
        description:
          "Produktbeanstandungen direkt hier über das Formular einreichen",
      },
      touch: {
        title: "Contact Touch Incentive",
        description:
          "Wenn Sie Fragen zu den Produkten im Bridgestone Plus-Geschenkshop, zu getätigten Bestellungen, Lieferzeiten und/oder Lieferungen haben, wenden Sie sich bitte an den externen Geschenkshop-Lieferanten: Touch Incentive Rotterdam: 010 2043075 oder support&#64;touchincentive.com.",
      },
    },
    strategicPartners: {
      cardTitle: "Kontakt zu unseren strategischen Partnern",
      title: "Kontakt zum Vertriebspartner",
      description:
        "Wir sind bereit für Sie! Nachfolgend finden Sie die Details Ihrer Großhändlerkontakte.",
      short_desc:
        "Haben Sie Fragen zu Ihren Reifenbestellungen bei angeschlossenen Händlern? Klicken Sie unten für die Kontaktdaten",
    },
  },
  contactPerson: "Ansprechpartner/in",
};

export default {
  messages,
};
